module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_en-798fe22f98b668108219989bd28e6b8c.jpg";